"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearGradient = void 0;
var color_1 = require("./color");
var linearGradient = function (gradient) {
    return "linear-gradient(".concat(gradient.to === 'Right' ? 'to right' : 'to left', ", ").concat((0, color_1.toHex)(gradient.startColor), " 50%, ").concat((0, color_1.toHex)(gradient.endColor), " 50%)");
};
exports.linearGradient = linearGradient;
